export default __webpack_public_path__ + "static/media/Buy credits (1).c0a7054f.svg";